<template>
  <van-tabbar
    v-model="active"
    inactive-color="#777777"
    active-color="#000000"
  >
    <van-tabbar-item
      v-for="(item,index) in tabbars"
      :key="index"
      :to="(item.name)"
    >
      <span>{{item.title}}</span>
      <img
        slot="icon"
        slot-scope="props"
        :src="props.active ? item.active : item.normal"
      />
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  name: 'tabbar',
  data () {
    return {
      active: 0,
      tabbars: [
        {
          name: '/',
          title: '首页',
          normal: require('../assets/imgs/icon1.png'),
          active: require('../assets/imgs/icon1H.png')
        },
        {
          name: '/train',
          title: '培训',
          normal: require('../assets/imgs/icon2.png'),
          active: require('../assets/imgs/icon2H.png')
        },
        {
          name: '/eEnter',
          title: '考核',
          normal: require('../assets/imgs/icon3.png'),
          active: require('../assets/imgs/icon3H.png')
        },
        {
          name: '/uc',
          title: '我',
          normal: require('../assets/imgs/icon4.png'),
          active: require('../assets/imgs/icon4H.png')
        }
      ]
    }
  },
  methods: {},
  // 通过路由跳转判断选中的样式
  created () {
    if (this.$route.name === '安全学习首页') {
      this.active = 0
    } else if (this.$route.name === '培训') {
      this.active = 1
    } else if (this.$route.name === '考核') {
      this.active = 2
    } else if (this.$route.name === '用户中心') {
      this.active = 3
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/tabbar.vue